import { getProductDummyImage } from "../mobileDummyImages";

const PRODUCT_MOCKUP_TYPES = new Set(["2", "3"]);

export function normalizeProductType(productType) {
  return String(productType ?? "");
}

export function isProductMockupType(productType) {
  return PRODUCT_MOCKUP_TYPES.has(normalizeProductType(productType));
}

function getRemoteProductImage(item = {}) {
  return item.image_url?.middle_url || item.image_url?.org_url || item.image_url?.small_url || "";
}

export function hasRemoteProductImage(item = {}) {
  return Boolean(getRemoteProductImage(item));
}

export function resolveProductImage(item = {}) {
  return getRemoteProductImage(item) || getProductDummyImage(item.product_type, item.product_type);
}
